<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col class="p-0 m-0">
          <h3 class="text-center"> 
            There are {{ Categoriesarray.length }} Categories
          </h3>
          <p class="text-center">Click any category to Edit</p>
          <categoryList
            v-for="(category, index) in usedatas"
            :key="index"
            :category="category"
            :where="loc"
          />
          <div class="text-center vmore" v-if="endnum < endss">
            <div class="viewmore" @click="showMore">
              <b-icon-chevron-down font-scale="2" class="mt-3" animation="cylon-vertical"
                >View More</b-icon-chevron-down
              >
            </div>
            <p class="p-1 m-1 textboldsf">Show More</p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import categoryList from "@/components/admin/categoryList.vue";
import { mapState, mapActions } from "vuex";
import store from "@/store";

export default {
  components: {
    categoryList,
  },

  data() {
    return {
        startnum: 0,
        limitnum: this.endss,
        intervalnum: 10,
        endnum: 10,
        loc : "editcategory"
    };
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("admin/fetchCategories");
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.setinextid(to.params.trackid).then(() => {
      next();
    });
  },
  created() {
    //this.fetchQuestions(this.name)
  },
  methods: {
    ...mapActions("admin", ["fetchCategories", "setinextid"]),
    showMore() {
      let newend = this.endnum + this.intervalnum;

      if (newend < this.endss) {
        this.endnum = newend;
      } else {
        this.endnum = this.limitnum;
      }
    },
  },
  computed: {
    ...mapState({
      name: (state) => state.loginmaster.details.fullname,
      Categoriesarray: (state) => state.admin.Categories,
    }),
    usedatas() {
      return this.Categoriesarray.slice(0, this.endnum);
    },
    endss() {
      let end = this.Categoriesarray.length;
      return end;
    },
  },
};
</script>

<style scoped>
.viewmore {
  background-color: rgb(241, 234, 234);
  border-radius: 100px;
  width: 50px;
  height: 50px;
  margin: 0px auto;
  box-shadow: 5px 5px 15px black;
  cursor: pointer;
}

.vmore {
  margin: 5px;
  padding: 10px;
}
</style>
